import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(authless)/login/")({
  beforeLoad: async () => {
    throw redirect({
      to: "/login/distributor",
    });
  },
});
